import type { Ref } from "vue";
import { ref } from "vue";
import useBritaMiddleware from "~/composables/useBritaMiddleware";

function useProductRegistrationNewsletterBase() {
  const { getLabelByPath } = useCommonLabels();
  const { register, getDoiState } = useBritaMiddleware();
  const technicalErrorMessage = getLabelByPath("/BWF/newsletter/doi/technicalErrorMessage");
  const { pushError } = useNotifications();

  const consentCheck: Ref<boolean> = ref(false);
  const doiAlreadyRegistered: Ref<boolean> = ref(false);
  const doiSubmitted: Ref<boolean> = ref(false);
  const isLoading: Ref<boolean> = ref(false);

  const newsletterDoiCheck = async (email) => {
    const registerable = ref(false);
    const data = await getDoiState(email);
    //@ts-ignore
    if (data?.donotbulkemail === false) {
      // user has already opted in
      doiAlreadyRegistered.value = true;
    } else {
      registerable.value = true;
    }
    return registerable;
  };

  const submitNewsletterRegistration = useDebounceFn(
    async (email, actionId, interactionId) => {
      isLoading.value = true;
      try {
        const doiCheckResponse = await newsletterDoiCheck(email);
        if (doiCheckResponse.value) {
          await register(email, interactionId, actionId);
          doiSubmitted.value = true;
        }
      } catch (e) {
        pushError(technicalErrorMessage);
        console.error("doi registration failed!", e);
      }
      isLoading.value = false;
    },
    300,
    { maxWait: 4000 },
  );

  return {
    submitNewsletterRegistration,
    doiAlreadyRegistered,
    newsletterDoiCheck,
    consentCheck,
    doiSubmitted,
    isLoading,
  };
}

// this wraps the composable in a shared instance
export const useProductRegistrationNewsletter = createSharedComposable(
  useProductRegistrationNewsletterBase,
);
